import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, TableRow } from '@mui/material';
import * as S from '../../styles';
const HeatingCircuitDetailsRow = memo(function HeatingCircuitDetailsRow(props) {
    const { label, value, label_icon, value_icon } = props;
    if (!(label || value)) {
        return null;
    }
    return (_jsxs(TableRow, { hover: true, children: [_jsx(S.DetailsCell, { children: _jsxs(Box, { display: "flex", alignItems: "center", columnGap: 1, children: [_jsx(Box, { fontSize: "1.4rem", display: "flex", alignSelf: "center", children: label_icon }), label] }) }), _jsx(S.DetailsCell, { children: _jsxs(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", columnGap: 1, children: [value, _jsx(Box, { fontSize: "1.4rem", display: "flex", alignSelf: "center", gap: 0.2, children: value_icon })] }) })] }));
});
export { HeatingCircuitDetailsRow };
